import React, { useRef } from "react";
import PropTypes from "prop-types";

const BubbleConnector = ({ isActive, angle, radius }) => {
  return (
    <>
      <div className="bubble-connector" data-cy="Ecosystem Bubble Connector"></div>
      <style jsx>
        {`
          .bubble-connector {
            position: absolute;
            transform-origin: top left;
            top: 50%;
            left: 50%;
            width: ${radius}%;
            height: 1px;
            background-color: white;

            box-shadow: rgba(255, 255, 255, 0.3) 0 0 10px 5px;
            animation: anim 300ms ${isActive ? "linear" : "ease"};
            animation-fill-mode: forwards;
            animation-direction: ${isActive ? "normal" : "reverse"};
          }

          @keyframes anim {
            from {
              transform: scale(0%);
              rotate: ${-1 * angle}rad;
            }

            to {
              transform: scale(100%);
              rotate: ${-1 * angle}rad;
            }
          }
        `}
      </style>
    </>
  );
};

BubbleConnector.propTypes = {};

export default BubbleConnector;
